/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CustomerAPIClient } from "../api_clients";
import { IAuthContext } from "../providers/CognitoAuthProvider";

export const getSystemNotifications = async (auth: IAuthContext) =>
  CustomerAPIClient.get(auth, "/api/system_notifications");
/* eslint-enable */
